module.exports = __webpack_public_path__ + "static/img/23.9fecc07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/23.jpg
// module id = soqd
// module chunks = 16